// extracted by mini-css-extract-plugin
module.exports = {"section":"alumni-artists-module--section--fCd2p","header":"alumni-artists-module--header--1WhyK","link":"alumni-artists-module--link--1euTZ"};